module.exports = __webpack_public_path__ + "img/sam-bucket-hat-02.10346b26.jpg";